<template>
    <div class="svg">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
            <title v-if="title">{{title}}</title>
            <circle :fill="fillColour" cx="12" cy="12" r="7"/>
        </svg>
    </div>
</template>

<script>
    export default {
        name: 'SvgBase',
        props: {
            'fill': {
                type: String,
                default: '#000'
            },
            'title': {
                type: String,
                default: ''
            }
        },
        computed: {
            fillColour: function () {
                
                switch (this.fill.toLowerCase()) {
                    case 'primary':
                        return getComputedStyle(document.documentElement).getPropertyValue('--colour-primary');
                    case 'secondary':
                        return getComputedStyle(document.documentElement).getPropertyValue('--colour-secondary');
                    case 'error':
                        return getComputedStyle(document.documentElement).getPropertyValue('--colour-error');
                    case 'warn':
                        return getComputedStyle(document.documentElement).getPropertyValue('--colour-warn');
                    case 'active':
                        return getComputedStyle(document.documentElement).getPropertyValue('--colour-active');
                    default:
                        return this.fill;
                }
                
            }   
        }
    };
</script>

<style scoped>
    
</style>